import { BaseDto } from './base.dto';

export class MultipleMerchantReportDto {
  merchantId: string;
  data: {
    source: string,
    total: number
  }[];
}
